export enum Roles {
  leadAccountmanager = "ROLE_LEAD_ACCOUNTMANAGER",
  accountmanager = "ROLE_ACCOUNTMANAGER",
  basicAccounting = "ROLE_BASIC_ACCOUNTING",
  accounting = "ROLE_ACCOUNTING",
  developer = "ROLE_DEVELOPER",
  productManager = "ROLE_PRODUCT_MANAGER",
  leadLawyer = "ROLE_LEAD_LAWYER",
  lawyer = "ROLE_LAWYER",
  external = "ROLE_EXTERNAL",
  admin = "ROLE_ADMIN",
  system = "ROLE_SYSTEM",
  user = "ROLE_USER",
  banking = "ROLE_BANKING",
  callcenter = "ROLE_CALLCENTER",
  traineeLawyer = "ROLE_TRAINEE_LAWYER",
}

export interface BackofficeUser {
  "@id": string;
  id: number;
  roles: Array<Roles>;
  email: string;
  person: BackofficePerson;
  avatar: string | null;
  calendlyId: string | null;
  isAccountManager: boolean;
  isLawyer: boolean;
  isExternal: boolean;
  status: string;
  hasBonusAccount?: boolean;
  responsibilities: Array<string>;
  "@type"?: "BackofficeUser";
}

interface LawyerTitle {
  title: string;
  fullTitle: string;
  product: string;
}

export interface BackofficePerson {
  "@id": string;
  id: number;
  titles: Array<LawyerTitle> | null;
  gender: string;
  givenName: string;
  familyName: string;
  nameAddition?: string | null;
  encodedSignature: string | null;
  fullname: string;
  beaData: boolean;
  telephone?: string;
  address?: BackofficeAddress;
}

export interface BackofficeAddress {
  id: number;
  postalCode: string;
  addressLocality: string | null;
  streetAddress: string | null;
}

export function isJsonLdBackofficeUser(obj: unknown): obj is BackofficeUser {
  return !!obj && typeof obj === "object" && "@type" in obj && obj["@type"] === "BackofficeUser";
}
